import React from 'react';
import { AnyEmptyQuestion } from '../../../../types';
import { StyledQuestionContainer } from './styles';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { DraggableHOC } from '../../../../../PlusWebsiteEditor/components/DraggableHOC/DraggableHOC';
import QuestionContent from './QuestionContent';
import { useSelector } from 'react-redux';
import { selectIsEditingAnyQuestion } from '../../../../../../redux/questionnaire/selectors';

interface Props {
  question: AnyEmptyQuestion;
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  index: number;
}

const DraggableQuestion = ({ question, provided, snapshot, index }: Props) => {
  const isEditingAnyQuestion = useSelector(selectIsEditingAnyQuestion);

  if (isEditingAnyQuestion) {
    return (
      <StyledQuestionContainer ref={provided.innerRef}>
        <QuestionContent index={index} question={question} />
      </StyledQuestionContainer>
    );
  }

  return (
    <DraggableHOC provided={provided} snapshot={snapshot}>
      <StyledQuestionContainer ref={provided?.innerRef} {...provided?.dragHandleProps} {...provided?.draggableProps}>
        <QuestionContent index={index} question={question} />
      </StyledQuestionContainer>
    </DraggableHOC>
  );
};

export default DraggableQuestion;
